import { useEditorStore } from '../store';

export function EditorStatusBar() {
  const nodes = useEditorStore((s) => s.nodes);
  const edges = useEditorStore((s) => s.edges);
  const canUndo = useEditorStore((s) => s.canUndo);
  const canRedo = useEditorStore((s) => s.canRedo);
  const undo = useEditorStore((s) => s.undo);
  const redo = useEditorStore((s) => s.redo);

  const cloudNodes = nodes.filter((n) => n.type === 'cloud').length;
  const groups = nodes.filter((n) => n.type === 'group').length;

  return (
    <div className="flex h-6 items-center justify-between border-t border-line-subtle bg-clyra-base/60 px-3 text-micro text-ink-faint">
      <div className="flex items-center gap-3">
        <span>{cloudNodes} nodes</span>
        {groups > 0 && <span>{groups} groups</span>}
        <span>{edges.length} edges</span>
      </div>

      <div className="flex items-center gap-0.5">
        <button
          onClick={undo}
          disabled={!canUndo}
          className="rounded px-1.5 py-0.5 text-micro text-ink-faint hover:text-ink-secondary hover:bg-clyra-overlay/30 disabled:opacity-25 disabled:cursor-default transition-colors"
        >
          Undo
        </button>
        <button
          onClick={redo}
          disabled={!canRedo}
          className="rounded px-1.5 py-0.5 text-micro text-ink-faint hover:text-ink-secondary hover:bg-clyra-overlay/30 disabled:opacity-25 disabled:cursor-default transition-colors"
        >
          Redo
        </button>
      </div>
    </div>
  );
}
